module.exports = ".btn-filter {\n  position: absolute;\n  top: 27px; }\n\n.envelope-box i.fa-envelope {\n  font-size: 2em;\n  color: #D5D5D5;\n  cursor: pointer;\n  padding-left: 20px; }\n\n.saldos-box {\n  padding-top: 15px;\n  padding-bottom: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-cuentas/catalogo-cuentas.component.scss
// module id = ./src/app/components/catalogo-cuentas/catalogo-cuentas.component.scss
// module chunks = main